const useMicrofrontend = (id: string, _url: string) => {
  const isLoaded = !!(window as any)[id];
  return { isLoaded, [id]: (window as any)[id] };
};
export default useMicrofrontend;
